module.exports = __webpack_public_path__ + "static/walker-hall-94868fedc15cc0406ff93fab9f1e3c18.png";